<template>
  <base-card tabled>
    <template v-slot:header>
      <base-card-heading>
        Project Details
      </base-card-heading>
      <base-button secondary small :to="{ name: 'projects.details', params: { id: project._id } }">
        Edit
      </base-button>
    </template>
    <template v-if="complete">
      <base-table>
        <colgroup>
          <col width="115" />
        </colgroup>
        <tbody>
          <tr>
            <th>Address</th>
            <td>
              <formatted-address :address="project.address"/>
            </td>
          </tr>
          <tr>
            <th>Term</th>
            <td>
              {{ project.projectedBuildPeriod ? `${project.projectedBuildPeriod} month(s)` : 'Not specified' }}
            </td>
          </tr>
          <tr>
            <th>Start Date</th>
            <td>
              {{ project.projectedStartDate ? $dates.toDate(project.projectedStartDate) : 'Not specified' }}
            </td>
          </tr>
          <tr>
            <th>End Date</th>
            <td>
              {{ project.projectedCompletionDate ? $dates.toDate(project.projectedCompletionDate) : 'Not specified' }}
            </td>
          </tr>
        </tbody>
      </base-table>
    </template>
    <template v-else>
      <div class="p-4 text-center">
        <p>
          Please complete the project details form.
        </p>
        <base-button primary small :to="{ name: 'projects.details', params: { id: project._id } }">
          Complete
        </base-button>
      </div>
    </template>
  </base-card>
</template>

<script>
import { mapState } from 'vuex'

import FormattedAddress from './FormattedAddress.vue'

export default {
  name: 'ProjectDetailsCard',

  components: {
    FormattedAddress
  },

  computed: {
    complete () {
      return this.project.stages.details
    },

    ...mapState({
      project: store => store.core.projects.entity
    })
  }
}
</script>
